<div class="full-height">
  <app-tech-radar [technologies]="technologies" [workStream]="workStream" *ngIf="technologies"></app-tech-radar>
</div>
